import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import { ScheduledQueryDrawerSource } from '@terminal/services/tracking/posthog/use-posthog-events/types';
import { useScheduleDrawerStore } from '@terminal/stores/use-schedule-drawer-store/useScheduleDrawerStore';
import type { WebSearch } from '@terminal/views/alfred/research/services/conversations-service';

export type { ScheduledQueryDrawerSource };

export type OpenScheduleDrawerParams = {
  source: ScheduledQueryDrawerSource;
  query?: string;
  priorWebSearch?: WebSearch;
};

export type OpenScheduleDrawerForEditParams = {
  source: ScheduledQueryDrawerSource;
  taskId: string;
};

export const useScheduleDrawerUrlSync = () => {
  const { params, setQueryParams, deleteQueryParam } = useQueryParams();
  const { storeOpen, storeClose, storeOpenForEdit } = useScheduleDrawerStore(
    state => ({
      storeOpen: state.open,
      storeClose: state.close,
      storeOpenForEdit: state.openForEdit,
    })
  );

  const isOpen =
    params[queryKeys.activeDrawer] === queryValues.scheduleQueryDrawer;

  const open = ({
    source,
    query,
    priorWebSearch,
  }: OpenScheduleDrawerParams) => {
    storeOpen(source, query, priorWebSearch);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.scheduleQueryDrawer,
    });
  };

  const openForEdit = ({ source, taskId }: OpenScheduleDrawerForEditParams) => {
    storeOpenForEdit(source, taskId);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.scheduleQueryDrawer,
    });
  };

  const close = () => {
    storeClose();
    deleteQueryParam(queryKeys.activeDrawer, { replace: true });
  };

  return { isOpen, open, openForEdit, close };
};
